export default __webpack_public_path__ + "static/media/JOSA.0bfa392e.pdf";